<template>
    <div class="wp">
        <el-aside ref="aside" width="200" class="wrapper" :class="isUnfold ? 'menu-isUnfold' : 'menu-collapsed'" >
            <core-sidebar-menus :menus="menus" :showisCollapsed="isUnfold" :collapse="isUnfold ? false : isCollapsed"></core-sidebar-menus>
            <!-- <div class="global-search" :class="isCollapsed ? '' : 'setBg'" v-if="showSearch">
                <el-input
                    ref="menuSerach"
                    placeholder="请输入内容"
                    v-model="searchMenuName"
                    @keyup.enter.native="handleEnter">
                    <i slot="prefix" style="font-size: 16px;margin-left: 9px;" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div> -->
        </el-aside>
        <!-- <div class="fixed-point" v-if="!isCollapsed" @click="handleFixedChange">
            <i v-if="isUnfold" class="el-icon-lock"></i>
            <i v-else class="el-icon-unlock"></i>
        </div> -->
    </div>
</template>
<script>
import { CoreSidebarMenus } from '@/components/core/themes/default/';
import { mapGetters, mapMutations } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';
const DELAY_TIME = 300;
export default {
    data() {
        return {
            isCollapsed: true,
            Timeout: null,
            searchMenuName: '',
            originMenu: [],
            showisCollapsed: false
        };
    },
    props: {
        showSearch: {
            type: Boolean,
            default: true
        },
        isUnfold: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        menus() {
            let menus = this.authority.length ? this.authority.map(item => {
                item['fdFrontLink'] = item.frontUrl;
                item['path'] = item.frontUrl;
                item['name'] = item.resourceName;
                return item;
            }) : [];
            // 过滤CSNP小程序权限 RE202309210001 - wx小程序
            return menus.filter(item => item.resourceCode !== 'RE202309210001');
        },
        ...mapGetters(['authority'])
    },
    methods: {
        handleFixedChange() {
            if (window._paq) {
                if (this.isUnfold) {
                    window._paq.push(['trackEvent', 'Menu', 'Click', '取消固定菜单']);
                } else {
                    window._paq.push(['trackEvent', 'Menu', 'Click', '固定菜单']);
                }
            }
            this.isUnfold = !this.isUnfold;
            this.handleMouseLeave();
        },
        getResourceIds(v) {
            const tempArr = [];
            getId(v);

            function getId(v) {
                v.forEach(item => {
                    if (item.resourceType && +item.resourceType === 1 && item.subResources) {
                        getId(item.subResources);
                    } else if (item.resourceType && +item.resourceType === 2) {
                        tempArr.push(item);
                    }
                });
            }
            return tempArr;
        },
        handleEnter() {
            if (this.searchMenuName) {
                let temp = this.getResourceIds(this.originMenu);
                temp = temp.filter(item => {
                    return item.resourceName.indexOf(this.searchMenuName) !== -1;
                });
                this.updateAuthority(temp);
            } else {
                this.updateAuthority(this.originMenu);
            }
            if (window._paq) {
                window._paq.push(['trackEvent', 'Menu', 'Enter', '菜单搜索']);
            }
        },
        handleMouseEnter() {
            clearTimeout(this.Timeout);
            this.Timeout = setTimeout(() => {
                this.isCollapsed = false;
            }, DELAY_TIME);
        },
        handleMouseLeave() {
            clearTimeout(this.Timeout);
            this.Timeout = setTimeout(() => {
                if (!this.isUnfold) {
                    this.isCollapsed = true;
                }
            }, DELAY_TIME * 5);
        },
        getElementInfo(element) {
            let info = '';
            const menuElement = element.closest('.el-menu-item');
            if (menuElement) {
                info = menuElement.innerText;
            }
            return info;
        },
        ...mapMutations({
            updateAuthority: 'updateAuthority'
        })
    },
    components: {
        CoreSidebarMenus
    },
    created() {
        this.originMenu = JSON.parse(JSON.stringify(this.menus));
    },
    mounted() {
        // 添加菜单访问统计
        this.$nextTick(() => {
            const { aside } = this.$refs;
            aside.$el.addEventListener('click', (e) => {
                const elementInfo = this.getElementInfo(e.target);
                // 大数据详情点击
                bigDataLog.sendDetailMessage({
                    model_name1: elementInfo
                });

                if (window._paq) {
                    let element = e.target;
                    if (element.classList.contains('menu-icon')) {
                        element = element.parentNode;
                    }
                    if (element.classList.contains('el-menu-item') || element.parentNode.classList.contains('el-menu-item')) {
                        window._paq.push(['trackEvent', 'Menu', 'Click', element.innerText]);
                    }
                }
            });
        });
    }
};
</script>
<style lang="less">
@delayTime: .3s;

.menu-isUnfold{
    width: 212px;
    transition: width 0.3s ease;
}
.menu-collapsed {
    width: 56px;
    transition: width 0.3s ease;
}
// .menu-collapsed:hover {
//     width: 200px;
//     transition: width 0.2s ease @delayTime;
//     .el-menu:not(.el-menu--collapse) {
//         width: 200px;
//     }
// }
.wp{
    position: relative;
    .fixed-point{
        width: 24px;
        height: 50px;
        position: absolute;
        top: 50%;
        right: -24px;
        transform: translateY(-25px);
        background-color: #51606e;
        color: #fff;
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        z-index: 999;
        box-shadow: 2px 2px 5px #888888;
    }
    .el-aside {
        background: #242c3e;
        //     /*三角箭头的颜色*/
        //     scrollbar-arrow-color: #fff;
        //     /*滚动条滑块按钮的颜色*/
        //     scrollbar-face-color: #0099dd;
        //     /*滚动条整体颜色*/
        //     scrollbar-highlight-color: #0099dd;
        //     /*滚动条阴影*/
        //     scrollbar-shadow-color: #0099dd;
        //     /*滚动条轨道颜色*/
        //     scrollbar-track-color: #0066ff;
        //     /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
        //     scrollbar-3dlight-color:#0099dd;
        //     /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
        //     scrollbar-darkshadow-color: #0099dd;
        //     /*滚动条基准颜色*/
        //     scrollbar-base-color: #0099dd;
        // 隐藏 滚动条
        -ms-scroll-chaining: chained;
        -ms-overflow-style: none;
        -ms-content-zooming: zoom;
        -ms-scroll-rails: none;
        -ms-content-zoom-limit-min: 100%;
        -ms-content-zoom-limit-max: 500%;
        -ms-scroll-snap-type: proximity;
        -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
        -ms-overflow-style: none;
    }
}
.wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #666;
    }
    .global-search{
        margin-bottom: 11px;
        height: 30px;
        padding: 16px;
        .el-input{
            margin-left: -3px;
            .el-input__inner{
                padding-left: 35px;
                background-color: rgba(255,255,255,0);
                border: none;
                color: #fff;
            }
            .el-input__prefix {
                left: -4px;
            }
        }
    }
    .setBg{
        .el-input{
            .el-input__inner{
                padding-left: 35px;
                background-color: rgba(255,255,255,0.1);
            }
        }
    }
}
</style>
